import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SignIn } from '@clerk/clerk-react';
import { shouldSkipOnboarding } from '../utils/roles';
import { useAuth } from '../contexts/AuthContext';
import AuthShell, { clerkAppearance } from '../components/auth/AuthShell';

const LoginPage: React.FC = () => {
  const { isAuthenticated, user, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading || !isAuthenticated || !user) return;
    navigate(
      user.onboarding_completed || shouldSkipOnboarding(user) ? '/dashboard' : '/onboarding'
    );
  }, [isAuthenticated, user, isLoading, navigate]);

  return (
    <AuthShell title="Connexion" subtitle="Accédez à votre espace RH">
      <SignIn
        routing="path"
        path="/login"
        signUpUrl="/register"
        forceRedirectUrl="/dashboard"
        fallbackRedirectUrl="/dashboard"
        appearance={clerkAppearance}
      />
    </AuthShell>
  );
};

export default LoginPage;
